<template lang="pug">
.inside-padding.container-tracking
  h3.capitalize Revisar Guías

  form(@submit.prevent="")
    .input-container
      input.input(v-model="trackingsNumber" type="text" autocomplete="ño" required)
      label.label(:class="{ show: trackingsNumber }") Número de Guías Separadas Por Comas
    .input-container.arrow
      label.label(:class="{ show: conveyor }") Transportadora
      select.select(v-model="conveyor" autocomplete="ño" required)
        option(value="" disabled)
        option(value="envia") Envía
        option(value="interapidisimo") Interapidísimo
    shActionButton(:isForm="true" text="Buscar" textRunning="Buscando" :action="getTracking")

  div(v-if="searched")
    .tracking(v-for="(tracking, index) in trackings")
      h3 Datos de la Guía {{ index + 1 }}
      div(v-if="tracking.error")
        div
          span.dark Guía:
          span  {{ tracking.number }}
        div
          span.dark Error
          span  {{ tracking.error }}

      div(v-else)
        div
          span.dark Guía:
          span  {{ tracking.number }}
        div
          span.dark Teléfono:
          span  {{ tracking.phoneRecipient }}
        .capitalize
          span.dark Nombre:
          span  {{ tracking.nameRecipient }}
        div
          span.dark Valor:
          span  {{ tracking.value }}
        div
          span.dark Remitente:
          span.capitalize  {{ tracking.nameSender }}

        .buttons-tracking
          shActionButton(:class="{'bg-principal': animationCopyParts}" text="Copiar Partes" textRunning="Copiando Partes" :action="copyParts" :params="[index]")
          shActionButton(:class="{'bg-principal': animationCopyAll}" text="Copiar Todo" textRunning="Copiando Todo" :action="copyAll" :params="[index]")
</template>

<script>
import mFilters from '@/mixins/filters'
import mForm from '@/mixins/form'

export default {
  name: 'Tracking',

  mixins: [mForm, mFilters],

  data () {
    return {
      trackingsNumber: '',
      conveyor: '',
      trackings: [{
        number: '',
        nameRecipient: '',
        phoneRecipient: '',
        value: '',
        nameSender: '',
        error: ''
      }],
      animationCopyParts: false,
      animationCopyAll: false,
      searched: false
    }
  },

  methods: {
    async getTracking () {
      if (this.conveyor === 'interapidisimo') {
        await this.getInterapidisimo()
      }
    },

    async getInterapidisimo () {
      this.searched = false
      this.trackings = []
      const trackingsCleaned = this.trackingsNumber.split(' ').join('').split(',')
      console.log(trackingsCleaned)

      for (let i = 0; i < trackingsCleaned.length; i++) {
        const trackingNumber = trackingsCleaned[i]
        try {
          const response = await fetch(`https://www3.interrapidisimo.com/ApiServInter/api/Mensajeria/ObtenerRastreoGuias?guias=${trackingNumber}`)
          const data = await response.json()
          const tracking = data[0]
          this.trackings.push({
            nameRecipient: tracking.Guia.Destinatario.Nombre.toLowerCase(),
            phoneRecipient: tracking.Guia.Destinatario.Telefono,
            nameSender: tracking.Guia.Remitente.Nombre.toLowerCase(),
            number: tracking.Guia.NumeroGuia,
            value: tracking.Guia.ValorTotal
          })
        } catch (error) {
          this.trackings.push({
            number: trackingNumber,
            error: error.message
          })
        }
      }

      this.searched = true
    },

    copyParts (index) {
      this.copyNavigator(this.trackings[index].number, null, false)
      setTimeout(() => {
        this.copyNavigator(this.trackings[index].phoneRecipient, null, false)
        setTimeout(() => {
          this.copyNavigator(this.trackings[index].value, this.doAnimationParts, true)
        }, 300)
      }, 300)
    },

    copyAll (index) {
      const data = `${this.trackings[index].number} - ${this.trackings[index].phoneRecipient} - ${this.trackings[index].value}`
      this.copyNavigator(data, this.doAnimationAll, true)
    },

    copyNavigator (text, cb, doAnimation = true) {
      try {
        const type = 'text/plain'
        const blob = new Blob([text], { type })
        const data = [new window.ClipboardItem({ [type]: blob })]
        navigator.clipboard.write(data)

        if (doAnimation) cb()
      } catch (error) {
        console.log('Característica sólo soportada en Chrome')
      }
    },

    doAnimationParts () {
      this.animationCopyParts = true
      setTimeout(() => { this.animationCopyParts = false }, 200)
    },

    doAnimationAll () {
      this.animationCopyAll = true
      setTimeout(() => { this.animationCopyAll = false }, 200)
    }
  }
}
</script>

<style lang="stylus" scoped>
.buttons-tracking
  display inline-flex
  gap 1em
  margin-top 1em

.container-tracking
  padding-bottom 2em
</style>



// WEBPACK FOOTER //
// src/components/pages/others/Tracking.vue